// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Rn5u","content":"LayoutSettings_content__3iYZh"};